import { useState } from 'react';
import { GovernanceHistorySchema, type GovernanceRevision } from '@easyflow/shared';
import { Button } from '@easyflow/ui-frontend/components/ui/button';
import { apiClient } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';

/** On-demand authorized history within existing routing/catalog surfaces. */
export default function AiGovernanceHistory({ global = false }: { global?: boolean }) {
  const { user } = useAuth();
  return <ScopedGovernanceHistory key={`${global}:${user?.tenantId ?? ''}:${user?.id ?? ''}`} global={global} />;
}

function ScopedGovernanceHistory({ global }: { global: boolean }) {
  const [rows, setRows] = useState<GovernanceRevision[] | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  async function load() {
    setLoading(true);
    setError('');
    try {
      const response = await apiClient.get<unknown>(global ? '/admin/models/governance-history' : '/tenant/ai-governance-history');
      setRows(GovernanceHistorySchema.parse(response.data));
    } catch {
      setError('Storico non disponibile: sono richiesti i permessi amministratore dello scope corrente.');
    } finally { setLoading(false); }
  }
  return <section className="space-y-2">
    <Button variant="outline" size="sm" disabled={loading} onClick={() => void load()}>
      {loading ? 'Caricamento…' : 'Storico configurazione e metadati AI'}
    </Button>
    {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
    {rows && <details open className="rounded border p-3 text-xs">
      <summary>{rows.length} revisioni recenti · snapshot senza segreti</summary>
      {rows.length === 0 && <p>Nessuna revisione registrata per questo scope.</p>}
      {rows.map(row => <div key={`${row.subject}:${row.revision}`} className="border-t py-2">
        <p>{row.subject} · rev {row.revision} (precedente {row.previous_revision})</p>
        <p>{row.created_at} · {row.actor} · {row.reason}</p>
        <dl className="grid grid-cols-2 gap-1">
          {Object.entries(row.snapshot).filter(([, value]) => value !== null).map(([key, value]) =>
            <div key={key}><dt className="text-muted-foreground">{key}</dt><dd className="break-all">{JSON.stringify(value)}</dd></div>)}
        </dl>
      </div>)}
    </details>}
  </section>;
}
